import { FormElement, FormError, FormSubmissionResponse } from '@uplift/types';
import { restClient } from '../../client';

export type PreviousElementRequest = {
  submission_id: string;
  form_element_id: string;
};

export type PreviousElementResponse =
  | {
    error: FormError;
  }
  | {
    element: FormElement;
    response: FormSubmissionResponse;
  };

export const previousElement = (data: PreviousElementRequest) =>
  restClient.request<PreviousElementResponse>('/api/v1/form/previous_element', {
    method: 'POST',
    data
  });
